<template>
  <div class="wrapper">
    <v-head></v-head>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>

<script>
import vHead from "./Header.vue";
import vFooter from "./Footer.vue";
import bus from "./bus";
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
    };
  },
  components: {
    vHead,
    vFooter,
  },
  created() {
    bus.$on("collapse-content", (msg) => {
      this.collapse = msg;
    });

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on("tags", (msg) => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
